module.exports = __webpack_public_path__ + "b81d9a6f224e8d88c3b9be78bf777fd2.svg";